import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal as ModalAntd, Spin } from 'antd'

import { Button, Modal } from 'src/components/Ant'
import {
  resetSaveFullRequest,
  saveFullRequest
} from 'src/core/store/ducks/requests/actions'
import { Request } from 'src/types'
import { ApplicationState } from 'src/store'
import { resetAir } from 'src/core/store/ducks/air/actions'
import { resetHotels } from 'src/core/store/ducks/hotels/actions'
import { resetVehicles } from 'src/core/store/ducks/vehicles/actions'
import { useT } from 'src/core/hooks/use-translation'

import SearchCardForm from '../SearchCard/form'
import SearchResultCardList from '../SearchResultCard/list'

type Props = {
  // itemEdit?: RequestItinerary
  request: Request
  toggle(): void
  visible: boolean
  approvals?: boolean
}

function ModalForm({
  // itemEdit,
  request,
  toggle,
  visible,
  approvals
}: Props) {
  const dispatch = useDispatch()
  const { requests, air } = useSelector((state: ApplicationState) => ({
    requests: state.requests,
    air: state.air
  }))

  const [saving, setSaving] = useState<boolean>(false)
  const { t } = useT()

  useEffect(() => {
    if (requests.saveFullRequestLoading !== saving && approvals && visible) {
      setSaving(requests.saveFullRequestLoading)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requests.saveFullRequestLoading])

  useEffect(() => {
    if (visible) {
      dispatch(resetAir())
      dispatch(resetHotels())
      dispatch(resetVehicles())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible])

  return (
    <Modal
      closable={!saving}
      forceRender
      maskClosable={!saving}
      title="web.services.airs.form.title"
      onCancel={() => {
        toggle()
        dispatch(resetSaveFullRequest())
      }}
      visible={visible}
      width={820}
      footer={
        !requests.saveFullRequestLoading
          ? [
              <Button
                key="cancel"
                onClick={() => {
                  toggle()
                  dispatch(resetSaveFullRequest())
                }}
                size="default"
                title="common.actions.cancel"
                type="default"
              />
            ]
          : []
      }
    >
      {requests.saveFullRequestLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 16 }}>
          <Spin />
        </div>
      ) : (
        <>
          <SearchCardForm request={request} />
          <SearchResultCardList
            onPick={selectedFares => {
              if (
                (air.searchType === 'ONE_WAY' &&
                  selectedFares.length === 1 &&
                  selectedFares[0].request_quote_air_fare_hash.length === 1) ||
                (air.searchType === 'ROUND_TRIP' &&
                  selectedFares.length === 1 &&
                  selectedFares[0].request_quote_air_fare_hash.length === 2) ||
                (air.searchType === 'MULTI-STRETCH' &&
                  selectedFares.length === Object.keys(air.searches).length)
              ) {
                ModalAntd.confirm({
                  cancelText: t('common.actions.cancel'),
                  content: t('web.services.alert-send-to-approval'),
                  okText: t('common.actions.yes'),
                  title: t('common.are-you-sure'),
                  onCancel() {},
                  onOk() {
                    dispatch(
                      saveFullRequest({
                        ...request,
                        full_request_air: selectedFares
                      })
                    )
                  }
                })
              }
            }}
          />
        </>
      )}
    </Modal>
  )
}

export default ModalForm
